import { i18ntrans } from 'language/i18nkey';
import { langutil } from 'language/langutil';
import svcs from 'services';
import styled from 'styled-components';
import icon_write from './icon/wright.svg';
import { useZstdInfo } from 'zstd/useZstdInfo';

type Props = {};
export const RenderPostpage = (props: Props) => {
  const { country, lang } = langutil.splitLangCode(svcs.svcLang.lang());
  const trans = (key: string): string => {
    return i18ntrans.header(key as any);
  };
  const { setShowUserPopup } = useZstdInfo();
  return (
    <UserPostpage>
      <button
        onClick={() => {
          window.open(`/${country}/${lang}/community/new/0`, '_blank');
          setShowUserPopup(false);
        }}>
        <img alt={'popup_post.svg'} src={icon_write} />
        {trans('I18N_TITLE_POST')}
      </button>
    </UserPostpage>
  );
};

const UserPostpage = styled.div`
  padding: 0 1rem;
  & button {
    padding: 1.6rem 2.2rem;
  }
`;
